// Onboarding (plan docs/ONBOARDING + DOCUSIGN/08-SLICE-B-REP-SIDE-PLAN.md §2
// [B1-1], [B2-4]): the rep's link carries its token in the URL fragment
// (/onboarding#t=…), which no server or CDN log sees. This module is the
// first import of src/index.tsx, so the token leaves the address bar before
// any other code runs: before Sentry, LogRocket, the router or the store can
// read the URL.
//
// The token is kept for this tab in sessionStorage (cleared when the tab
// closes), so a reload or a 30-minute sign-out can still ask for a new code.

export const ONBOARDING_PATH = '/onboarding';
const TOKEN_KEY = 'clix.onboarding.token';
const TOKEN_FORMAT = /^[A-Za-z0-9_-]{43}$/;

export const isOnboardingPath = (pathname = window.location.pathname) => {
  const path = pathname.toLowerCase();
  return path === ONBOARDING_PATH || path.startsWith(`${ONBOARDING_PATH}/`);
};

const store = {
  get: () => {
    try {
      return window.sessionStorage.getItem(TOKEN_KEY);
    } catch {
      return null;
    }
  },
  set: (value: string) => {
    try {
      window.sessionStorage.setItem(TOKEN_KEY, value);
    } catch {
      // Private mode: the token lives in memory for this page only.
    }
  },
};

let token: string | null = null;

/** Takes `#t=…` off the address bar and keeps it. Runs once, at import. */
export const takeOnboardingFragment = () => {
  const { hash, search, pathname } = window.location;
  if (!isOnboardingPath(pathname) || !hash) {
    return;
  }
  const value = new URLSearchParams(hash.slice(1)).get('t');
  window.history.replaceState(window.history.state, '', `${pathname}${search}`);
  if (value && TOKEN_FORMAT.test(value)) {
    token = value;
    store.set(value);
  }
};

/** The rep's link token for this tab, if the page was opened from a link. */
export const onboardingToken = () => {
  if (!token) {
    const kept = store.get();
    token = kept && TOKEN_FORMAT.test(kept) ? kept : null;
  }
  return token;
};

takeOnboardingFragment();
